<template>
  <div>
    <span class="icon-padding-right"><i class="mdi mdi-circle-medium" /></span>
    <span class="ct-text-muted">Total : </span>
    <span class="ct-text-main">{{ $_utils.comma(count) }}</span>
    <span class="ct-text-muted"> {{ unit }}</span>

    <template v-if="!$_utils.isEmpty(totalCount)">
      <span class="ct-text-muted"> / </span>
      <span class="text-black">{{ $_utils.comma(totalCount) }}</span>
      <span class="ct-text-muted"> {{ unit }}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    count: Number,
    totalCount: Number,
    unit: String
  }
}
</script>
